import type { z } from 'zod';
import { longTextField } from '@/entities/shared/schemas/long-text-field';
import { nameField } from '@/entities/shared/schemas/name-field';
import { tagField } from '@/entities/shared/schemas/tag-field';
import { zs } from '@/entities/shared/schemas/zod';

/** Free text: plans, contacts, procedures. Mirrors …/collections/note.py. */
export const noteSchema = zs.looseObject({
  title: nameField,
  body: longTextField.default(''),
  tags: zs.array(tagField).default([]),
  pinned: zs.boolean().default(false),
});

export type Note = z.infer<typeof noteSchema>;
